import { useIsMobile } from '@/hooks/use-mobile.tsx';
import { SIDEBAR_WIDTH, SidebarProvider } from '@/components/ui/sidebar.tsx';
import AppSidebar from '@/features/dashboard/_root/components/AppSidebar.tsx';
import AppHeader from '@/features/dashboard/_root/components/AppHeader.tsx';
import AppMobileMenu from '@/features/dashboard/_root/components/AppMobileMenu.tsx';
import { Outlet } from '@tanstack/react-router';
import { cn } from '@/lib/utils';

const AppLayout = () => {
  const isMobile = useIsMobile();

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-basic-white">
        {isMobile ? <AppMobileMenu /> : <AppSidebar />}
        <main
          className="flex-1 overflow-y-auto"
          style={{ marginLeft: isMobile ? 0 : SIDEBAR_WIDTH }}
        >
          {isMobile && (
            <div className="sticky top-0 z-10 flex items-center border-b border-neutral-200 bg-basic-white p-4">
              <AppHeader />
            </div>
          )}
          {/* Dolny odstęp na telefonie: pastylka menu nie może zasłaniać końca treści. */}
          <div className={cn('mx-auto max-w-7xl p-6', isMobile && 'pb-28')}>
            <Outlet />
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
};

export default AppLayout;
